const translations = {
  'nav.home': 'Главная',
  'nav.categories': 'Категории',
  'nav.articles': 'Статьи',
  'nav.about': 'О нас',
  'nav.goto': 'Перейти в магазин',

  'hero.tag': 'Лучший способ покупать из Китая в 2026',
  'hero.title': 'YOYBUY Spreadsheet',
  'hero.subtitle': 'Система управления заказами, которая экономит до 40% на покупках из Китая',
  'hero.cta': 'Начать покупать',

  'categories.title': 'Категории товаров',
  'categories.select': 'Выберите категорию',
  'categories.all': 'Все категории',

  'cta.main.title': 'Покупайте умнее с YOYBUY',
  'cta.main.subtitle': 'Тысячи пользователей уже экономят на каждом заказе',
  'cta.button1': 'yoybuy sheet',
  'cta.button2': 'buy it now',

  'stats.title': 'Почему покупатели выбирают YOYBUY',
  'stats.orders': 'Тысячи обработанных заказов',
  'stats.savings': 'Экономия на доставке',
  'stats.countries': 'Стран доставки',
  'stats.rating': 'Рейтинг доверия',

  'articles.title': 'Руководства и обзоры',
  'articles.subtitle': 'Узнайте всё о покупках из Китая через YOYBUY Spreadsheet',
  'articles.readMore': 'Читать далее',
  'articles.readTime': 'мин чтения',

  'bottomCta.title': 'Начните покупать через YOYBUY Spreadsheet сегодня',
  'bottomCta.subtitle': 'Присоединяйтесь к тысячам пользователей, которые уже экономят на каждом заказе из Китая',

  'footer.brand': 'YOYBUY.WTF',
  'footer.links': 'Полезные ссылки',
  'footer.social': 'Социальные сети',
  'footer.subscribe': 'Подпишитесь на обновления',
  'footer.subscribePlaceholder': 'Ваш email',
  'footer.subscribeButton': 'Подписаться',
  'footer.copyright': '© 2026 YOYBUY. Все права защищены.',
  'footer.home': 'Главная',
  'footer.categories': 'Категории',
  'footer.articles': 'Статьи',
  'footer.compare': 'Сравнение платформ',
  'footer.spreadsheet': 'YOYBUY Spreadsheet',

  'article.related': 'Похожие статьи',
  'article.backToHome': '← Вернуться на главную',
  'article.tableOfContents': 'Содержание',
  'article.published': 'Опубликовано',
  'article.updated': 'Обновлено',
  'article.author': 'Автор',
  'article.readTime': 'время чтения',
  'article.share': 'Поделиться',
  'article.relatedArticles': 'Похожие статьи',
  'article.ctaTitle': 'Готовы начать?',
  'article.ctaText': 'Перейдите на YOYBUY Spreadsheet и начните экономить на покупках из Китая уже сегодня.',
  'article.ctaButton': 'Перейти к YOYBUY',
  'article.faqTitle': 'Часто задаваемые вопросы',

  'site.name': 'YOYBUY.WTF',
  'site.description': 'YOYBUY Spreadsheet — лучшая система покупок товаров из Китая. Обувь, одежда, аксессуары с доставкой по всему миру.',
  'btn.learnMore': 'Узнать больше',
  'btn.readMore': 'Читать далее',
  'btn.shopNow': 'Купить сейчас',
  'btn.back': 'Назад',
  '404.title': 'Страница не найдена',
  '404.subtitle': 'Запрашиваемая страница не существует или была перемещена',
  '404.backHome': 'Вернуться на главную',
};

export default translations;